// TODO: FABRIC_DPI is fabric.DPI, Better use fabric.DPI without import whole fabric lib
const FABRIC_DPI = 96;

export const convertPixelToOtherUnit = (pixelValue, newUnit) => {
  switch (newUnit) {
    case 'mm':
      return ((pixelValue * 25.4) / FABRIC_DPI).toFixed();
    case 'cm':
      return ((pixelValue * 2.54) / FABRIC_DPI).toFixed();
    case 'in':
      return (pixelValue / FABRIC_DPI).toFixed();
    default:
      return pixelValue;
  }
};
